import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/custom-datepicker.css"; // Custom styles for the date picker
const CustomDatePicker = ({ 
  id, 
  selectedDate, 
  onChange, 
  disabledDateRanges, 
  minDate, 
  placeholderText,
  isInvalid,
  errorMessage,
  showTimeSelect = true,
  filterDate = null,
  disabled = false
}) => {
  // State to track the selected date internally
  const [date, setDate] = useState(selectedDate ? new Date(selectedDate) : null);
  
  // Update internal state when prop changes
  useEffect(() => {
    if (selectedDate) {
      setDate(new Date(selectedDate));
    } else {
      setDate(null);
    }
  }, [selectedDate]);

  // Function to check if a date is within any disabled date range
  const isDateDisabled = (date) => {
    if (!disabledDateRanges || disabledDateRanges.length === 0) return false;
    
    return disabledDateRanges.some(range => {
      const start = new Date(range.start);
      const end = new Date(range.end);
      return date >= start && date <= end;
    });
  };

  // Handle date change
  const handleDateChange = (newDate) => {
    setDate(newDate);
    
    // Format date for parent component
    const formattedDate = newDate ? newDate.toISOString().slice(0, 16) : "";
    
    // Call parent onChange with id and formatted date
    onChange({
      target: {
        id,
        value: formattedDate
      }
    });
  };

  return (
    <div className="custom-datepicker position-relative w-100">
      <DatePicker
        selected={date}
        onChange={handleDateChange}
        minDate={minDate || new Date()}
        placeholderText={placeholderText || "Select date..."}
        showTimeSelect={false}
        timeFormat="HH:mm"
        timeIntervals={30}
        dateFormat="MMMM d, yyyy h:mm aa"
        className={`form-control w-100 ${isInvalid ? 'is-invalid' : ''}`}
        excludeDates={[]} // Individual dates to exclude
        filterDate={filterDate || (date => !isDateDisabled(date))}
        disabled={disabled}
        popperClassName="date-picker-popper"
        popperPlacement="right-start"
        isClearable
        highlightDates={[
          {
            "react-datepicker__day--highlighted-custom-1": 
              disabledDateRanges?.map(range => {
                // Convert range to array of dates
                const dates = [];
                let currentDate = new Date(range.start);
                const endDate = new Date(range.end);
                
                while (currentDate <= endDate) {
                  dates.push(new Date(currentDate));
                  currentDate.setDate(currentDate.getDate() + 1);
                }
                
                return dates;
              }).flat() || []
          }
        ]}
      />
      <div className="calendar-icon">
        {/* <i className="fas fa-calendar-alt text-muted"></i> */}
        <span>📅</span>
      </div>
      {isInvalid && errorMessage && (
        <div className="invalid-feedback d-block">
          {errorMessage}
        </div>
      )}
      <style jsx>{`
        .custom-datepicker {
          display: block;
          width: 100%;
        }
        .react-datepicker-wrapper {
          display: block;
          width: 100%;
        }
        .react-datepicker__input-container {
          display: block;
          width: 100%;
        }
        .react-datepicker__input-container input {
          width: 100%;
          padding-right: 30px; /* Make space for the calendar icon */
        }
        .calendar-icon {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
          pointer-events: none;
          color: #6c757d;
          font-size: 16px;
        }
        .react-datepicker__day--highlighted-custom-1 {
          background-color: #f0f0f0;
          color: #999;
          pointer-events: none;
        }
        .react-datepicker {
          font-size: 0.9rem;
        }
        .date-picker-popper {
          z-index: 1060 !important; /* Ensures datepicker appears above other elements */
        }
      `}</style>
    </div>
  );
};

export default CustomDatePicker;